import { forwardRef } from "react";

import { Avatar, Button, Icon_TriangleDown } from "@shapr3d/frontend-lib";
import type { ButtonHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import { useTeam } from "../../hooks/useTeams";
import useTranslation from "../../hooks/useTranslation";

import style from "./TeamSelectorActivator.module.css";

export const TeamSelectorActivator = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ ...attrs }, ref) => {
  const { m } = useTranslation();
  const { teamID } = useParams();
  const { teamData } = useTeam(teamID);

  return (
    <Button {...attrs} ref={ref} className={style.teamSelectorActivator} variant="grayscale">
      <div className={style.content}>
        <Avatar text={teamData?.name} className={style.avatar} />
        <div className={style.nameContainer}>
          <div className={style.name}>{teamData?.name}</div>
          <div className={style.subTitleContainer}>
            <div className={style.subscriptionBadge}>{teamData?.subscriptionBadge}</div>
            {teamData?.memberCount && (
              <>
                <span>·</span>
                <div>
                  <FormattedMessage
                    id={m.TeamSelector.MemberCount.id}
                    defaultMessage={m.TeamSelector.MemberCount.defaultMessage}
                    values={{
                      count: teamData?.memberCount,
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className={style.arrowIcon}>
          <Icon_TriangleDown />
        </div>
      </div>
    </Button>
  );
});
